import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpSharedIconBubbles.scss';

// Components
import PinterestIcon from 'dibs-vg/dist/react/pinterest';

// helpers
import SV from 'server-vars';
import get from 'lodash.get';
import classnames from 'classnames';
import { trackPinterestClick } from '../tracking/iconBubblesTracking';
import { pin } from '../../components/social/socialActions';
import { intlShape, injectIntl, defineMessages } from 'react-intl';

// messages
const messages = defineMessages({
    description: {
        id: 'PdpSharedIconBubblePinterest.description',
        defaultMessage:
            '{title} | From a unique collection of {vertical, select, furniture {antique and modern} jewelry {vintage} fashion {rare vintage} other {} } {categoryName} at {dotComHost}{categoryUrl}.',
    },
});

function getValues(item) {
    const categories = get(item, 'classification.categories');
    const { category } = categories.find(({ precedence }) => precedence === 1);
    return {
        title: item.title,
        vertical: item.vertical,
        categoryName: category.name,
        categoryUrl: category.browseUrl,
        dotComHost: SV.get('config.dotComHost'),
    };
}

function onClick({ item, intl }) {
    const { formatMessage } = intl;
    // fire tracking
    trackPinterestClick(item.title);
    // launch pinterest window
    pin({
        newBrowserWindow: true,
        title: item.title,
        media: get(item, 'photos[0].largePath'),
        url: `${SV.get('config.dotComHost')}${item.pdpURL}`,
        description: formatMessage(messages.description, getValues(item)),
    });
}

const className = classnames(styles.bubble, styles.pinterest);
function PdpSharedIconBubblePinterest(props) {
    return (
        <div className={className} onClick={() => onClick(props)}>
            <PinterestIcon className={styles.icon} />
        </div>
    );
}

PdpSharedIconBubblePinterest.propTypes = {
    item: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

export default createFragmentContainer(injectIntl(PdpSharedIconBubblePinterest), {
    item: graphql`
        fragment PdpSharedIconBubblePinterest_item on Item {
            title
            pdpURL
            vertical
            classification {
                categories {
                    precedence
                    category {
                        name
                        browseUrl
                    }
                }
            }
            photos {
                largePath
            }
        }
    `,
});
